import { config } from "@/config";
import { useApi } from "@/hooks/use-api";
import { useAppDispatch, useAppState } from "@/store/useApp";
import { useFlow } from "@frigade/react";
import { useEffect, useState } from "react";
import { useParams } from "react-router";
import { Grading } from "./Grading";

export const GradingContainer = () => {
    const { documentId } = useParams();
    const [isLoading, setIsLoading] = useState(false);
    const { fetchGrading } = useApi();
    const dispatch = useAppDispatch();

    const isReferencesPanelOpen = useAppState(
        (state) => state.referencePanel.visible
    );
    const grading = useAppState((state) => state.grading);
    const currentDocument = useAppState((state) => state.currentDocument);
    const { flow: feedbackFlow } = useFlow(config.frigade.flows.feedbackHint);

    useEffect(() => {
        const loadData = async () => {
            if (!documentId || !currentDocument) {
                setIsLoading(false);
                return;
            }

            const needsGrading = !grading;

            if (needsGrading) {
                try {
                    await fetchGrading(documentId);
                } finally {
                    setIsLoading(false);
                }
            } else {
                setIsLoading(false);
            }
        };

        loadData();
    }, [documentId, currentDocument, grading, fetchGrading]);

    const handleTabChange = (value: string) => {
        if (value === "feedback") {
            if (feedbackFlow && !feedbackFlow.isCompleted) {
                feedbackFlow.complete();
            }

            if (isReferencesPanelOpen) {
                dispatch({
                    type: "SHOW_REFERENCE_PANEL",
                    payload: { visible: false },
                });
            }
        }
    };

    return (
        <Grading
            isLoading={isLoading}
            isReferencesPanelOpen={isReferencesPanelOpen}
            feedbackStatus={grading?.feedback?.status}
            onTabChange={handleTabChange}
        />
    );
};
